 
import React, { ReactElement } from 'react';

import { Container, GridItem } from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import TextWrapper from 'components/customWrapper/TextWrapper';

import { JOURNEY_STEPS } from '../../../constants/analytics.constants';
import * as Analytics from '../../../utils/analytics';
import {
  ACCOUNT_NUMBER,
  ACCOUNT_NUMBER_PATTERN,
  BUSINESS_NAME,
  BUSINESS_NAME_PATTERN,
  HOCA_SORT_CODE_PATTERN,
  SORT_CODE,
  SORT_CODE_PATTERN,
} from '../../../utils/constant';
import { BusinessInputsPropsType } from '../../../utils/types';
import { AboutBusinessContent } from '../AboutBusinessContent';

function BusinessInputs({
  register,
  setValue,
  control,
  errors,
  setIsExistSortCode,
}: BusinessInputsPropsType): ReactElement {
  const { aboutBusinessContent } = useContent<AboutBusinessContent>();
  const brand: string = (window as any)?.appConfig?.BRAND_NAME;

  return (
    <Container padding="none">
      {aboutBusinessContent?.map(
        ({
          enterBusinessName,
          businessNameContains,
          businessNameMaxText,
          startsWith_1,
          startsWith_2,
          enterBrandCode,
          businessNameLabel,
          businessNameSupportText,
          sortCodeLabel,
          enterSortCode,
          sortCodeDigits,
          enterAccountNumber,
          accountNumberDigits,
          accountNumberLabel,
        }) => (
          <GridItem key="content">
            <TextWrapper
              name={BUSINESS_NAME}
              {...register(BUSINESS_NAME, {
                required: enterBusinessName,
                pattern: {
                  value: BUSINESS_NAME_PATTERN,
                  message: businessNameContains,
                },
                validate: {
                  textMaxLimit: (value) => {
                    if (value.length > 120) {
                      return businessNameMaxText;
                    }
                    return true;
                  },
                  notOnlySpace: (value) => {
                    if (value.trim() === '') {
                      return enterBusinessName;
                    }
                    return true;
                  },
                },
              })}
              label={businessNameLabel}
              setValue={setValue}
              taggingLabel={businessNameLabel}
              supportiveText={businessNameSupportText}
              error={errors?.businessName?.message}
              maxLength={120}
              control={control}
            />
            <TextWrapper
              label={sortCodeLabel}
              taggingLabel={sortCodeLabel}
              name={SORT_CODE}
              {...register(SORT_CODE, {
                required: enterSortCode,
                pattern: {
                  value: SORT_CODE_PATTERN,
                  message: sortCodeDigits,
                },
                validate: {
                  startsWith: (value) => {
                    if (
                      brand === 'lloyds' &&
                      HOCA_SORT_CODE_PATTERN.test(value)
                    ) {
                      Analytics.setPageLoadEvent(
                        JOURNEY_STEPS.ONLINE_REGISTRATION
                          .ABOUT_THE_BUSINESS_ERROR_HOCA,
                      );
                      setIsExistSortCode(true);
                      return true;
                    }
                    setIsExistSortCode(false);
                    return (
                      value.startsWith(startsWith_1) ||
                      value.startsWith(startsWith_2) ||
                      enterBrandCode
                    );
                  },
                },
              })}
              setValue={setValue}
              control={control}
              error={errors?.sortCode?.message}
            />
            <TextWrapper
              label={accountNumberLabel}
              taggingLabel={accountNumberLabel}
              name={ACCOUNT_NUMBER}
              {...register(ACCOUNT_NUMBER, {
                required: enterAccountNumber,
                pattern: {
                  value: ACCOUNT_NUMBER_PATTERN,
                  message: accountNumberDigits,
                },
              })}
              error={errors?.accountNumber?.message}
              setValue={setValue}
              control={control}
            />
          </GridItem>
        ),
      )}
    </Container>
  );
}

export default BusinessInputs;
